document.addEventListener('DOMContentLoaded', function() {
  var toggles = document.querySelectorAll('.menu__toggle');
  var subToggles = document.querySelectorAll('.menu__sub-toggle');

  // Event-Listener zu den Haupt-Toggles hinzufügen
  toggles.forEach(function(toggle) {
    var title = toggle.querySelector('.menu__toggle-title');
    
    title.addEventListener('click', function() {
      var isOpened = toggle.classList.contains('menu__toggle--opened');
      
      toggles.forEach(function(item) {
        if (item !== toggle) {
          item.classList.remove('menu__toggle--opened');
        }
      });

      if (!isOpened) {
        toggle.classList.add('menu__toggle--opened');
      } else {
        toggle.classList.remove('menu__toggle--opened');
      }
    });
  });

  // Event-Listener zu den Sub-Toggles hinzufügen
  subToggles.forEach(function(subToggle) {
    var subTitle = subToggle.querySelector('.menu__sub-toggle-title');
    
    subTitle.addEventListener('click', function() {
      var isSubOpened = subToggle.classList.contains('menu__sub-toggle--opened');
      
      subToggles.forEach(function(item) {
        if (item !== subToggle) {
          item.classList.remove('menu__sub-toggle--opened');
        }
      });

      if (!isSubOpened) {
        subToggle.classList.add('menu__sub-toggle--opened');
      } else {
        subToggle.classList.remove('menu__sub-toggle--opened');
      }
    });
  });
});
